import 'css-chunk:src/app/components/ApplicationPageTemplates/common/HeroMedia/HeroMedia.scss';export default {
  "HeroImage": "_HeroImage_xmgw1_1",
  "image": "_image_xmgw1_1",
  "video": "_video_xmgw1_4"
};